import { NextPage } from 'next';
import { useRouter } from 'next/router'
import { Affix } from 'antd';
import React from 'react';
import { AddPic, Platte, BackgroundColor, Like, ColorFilter, ColorCard } from '@icon-park/react'
import Link from 'next/link';
import { colorPrimary } from '../../constants/heads';
const Navigation: NextPage = () => {
    const router = useRouter()
    const path = router.pathname
    const getActive = (name:string,type:string)=>{
        if (type == 'fill'){
            return path == name ? colorPrimary : "#333"
        }
    }
    return (
        <Affix className="left" offsetTop={72}>
            <>
                <Link href="/colors/plate">
                    <a className={path == '/colors/plate'?'active':''}>
                        <ColorCard theme={path == '/colors/plate' ? "filled" : "outline"} size="22" fill={getActive('/colors/plate', "fill")} strokeWidth={3} />色板
                    </a>
                </Link>
                <Link href="/colors/gradual">
                    <a className={path == '/colors/gradual' ? 'active' : ''}>
                        <ColorFilter theme={path == '/colors/gradual' ? "filled" : "outline"} size="24" fill={getActive('/colors/gradual', "fill")} strokeWidth={3} />渐变
                    </a>
                </Link>
                <Link href="/colors/background">
                    <a className={path == '/colors/background' ? 'active' : ''}>
                        <BackgroundColor theme={path == '/colors/background' ? "filled" : "outline"} size="24" fill={getActive('/colors/background', "fill")} strokeWidth={3} />背景
                    </a>
                </Link>
                <Link href="/colors/upload">
                    <a className={path == '/colors/upload' ? 'active' : ''}>
                        <AddPic theme={path == '/colors/upload' ? "filled" : "outline"} size="24" fill={getActive('/colors/upload', "fill")} strokeWidth={3} />取色
                    </a>
                </Link>
                <Link href="/colors/like">
                    <a className={path == '/colors/like' ? 'active' : ''}>
                        <Like theme={path == '/colors/like' ? "filled" : "outline"} size="24" fill={getActive('/colors/like', "fill")} strokeWidth={3} />收藏
                    </a>
                </Link>
            </>
        </Affix>
    )
}

export default Navigation